import { isFulfilled, isPending, isRejected } from "../../utils/redux/action-utils.js";
import { onFulfilled, onPending, onRejected } from "../../utils/redux/state-utils.js";
import { viewPortInitialState } from "./initial-state.js";
//#region src/redux/view-port/extra-reducers.ts
var isActionFulfilled = (action) => isFulfilled(action, "viewport");
var isActionPending = (action) => isPending(action, "viewport");
var isActionRejected = (action) => isRejected(action, "viewport");
var isSignOut = (action) => isFulfilled(action, "auth/signOut");
var onSignOut = (state) => {
	state.viewPort = viewPortInitialState.viewPort;
	state.isPending = viewPortInitialState.isPending;
	state.isRejected = viewPortInitialState.isRejected;
	state.errorMessage = viewPortInitialState.errorMessage;
};
var extraReducers = (builder) => {
	builder.addMatcher(isActionFulfilled, onFulfilled).addMatcher(isActionPending, onPending).addMatcher(isActionRejected, onRejected).addMatcher(isSignOut, onSignOut);
};
//#endregion
export { extraReducers };

//# sourceMappingURL=extra-reducers.js.map